/**
 * @voltxampere/web — Simulation category builtin commands (Sprint 22 C3)
 *
 * 9 commands covering the three analyses (DC / transient / AC), live
 * mode toggle, stop, reset, result export, and dialog launchers for
 * transient + AC config (Sprint 21 C7 acConfigDialog landing).
 *
 * Copyright © 2026 360 Studio
 * Proprietary — All rights reserved.
 */

import type { Command } from "../types.js";
import { acConfigDialogOpen } from "../../components/vxa-ac-config-dialog.js";
import { transientLive } from "../../store/transient-runner.js";

const noop = (): void => {
  /* Sprint 22 stub for direct-run paths; UI surfaces existing F5/F6 keyboards. */
};

export const SIMULATION_COMMANDS: readonly Command[] = [
  {
    id: "sim.run-dc",
    titleKey: "command.sim.runDc",
    descriptionKey: "command.sim.runDc.desc",
    category: "simulation",
    shortcut: "F4",
    execute: noop, // DC OP run trigger lands with S23 dedicated DC pane
  },
  {
    id: "sim.run-transient",
    titleKey: "command.sim.runTransient",
    descriptionKey: "command.sim.runTransient.desc",
    category: "simulation",
    shortcut: "F5",
    execute: noop, // F5 keyboard already wires; palette is a discovery alias
  },
  {
    id: "sim.run-ac",
    titleKey: "command.sim.runAc",
    descriptionKey: "command.sim.runAc.desc",
    category: "simulation",
    shortcut: "F6",
    execute: () => {
      acConfigDialogOpen.value = true;
    },
  },
  {
    id: "sim.toggle-live",
    titleKey: "command.sim.toggleLive",
    descriptionKey: "command.sim.toggleLive.desc",
    category: "simulation",
    execute: () => {
      transientLive.value = !transientLive.value;
    },
  },
  {
    id: "sim.stop",
    titleKey: "command.sim.stop",
    category: "simulation",
    execute: () => {
      transientLive.value = false;
    },
  },
  {
    id: "sim.reset",
    titleKey: "command.sim.reset",
    descriptionKey: "command.sim.reset.desc",
    category: "simulation",
    execute: noop,
  },
  // Sprint 80.Z Phase 4 D1 — `sim.export-results` removed
  // (CSV / SVG export not wired). Re-lands with the export pipeline.
  {
    id: "sim.config-ac",
    titleKey: "command.sim.configAc",
    descriptionKey: "command.sim.configAc.desc",
    category: "simulation",
    execute: () => {
      acConfigDialogOpen.value = true;
    },
  },
  {
    id: "sim.config-transient",
    titleKey: "command.sim.configTransient",
    category: "simulation",
    execute: noop, // Sprint 23+ transient sweep dialog
  },
];
